module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_cdp-small-65b3582767070b1989d4cdd77b2669fc.png";